import { FilterOptions } from "@/types/FilterOptions";
import { SearchFilterV4 } from "@/types/SearchFilter";
import { Checkbox } from "@components/ui/checkbox";
import {
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from "@components/ui/command";
import { Trans } from "@lingui/react/macro";
import { ChevronLeftIcon } from "lucide-react";

export default function PageChannelTypes({
  options,
  onChange,
  value,
  onBack,
}: {
  onChange?: (value: SearchFilterV4, clear?: boolean) => void;
  value: SearchFilterV4["channel_type"];
  options: FilterOptions["filter_sources"];
  onBack?: () => void;
}) {
  // Helpers
  const isArray = Array.isArray(value);

  const isAllSelected = isArray && value.length === options.length;

  return (
    <>
      {onBack && (
        <>
          <CommandGroup>
            <CommandItem onSelect={onBack}>
              <ChevronLeftIcon />
              <Trans>Tillbaka</Trans>
            </CommandItem>
          </CommandGroup>

          <CommandSeparator />
        </>
      )}

      <CommandGroup>
        {isAllSelected ? (
          <CommandItem
            onSelect={() => {
              onChange?.({
                channel_type: undefined,
              });
            }}
          >
            <Trans>Avmarkera alla</Trans>
          </CommandItem>
        ) : (
          <CommandItem
            onSelect={() => {
              onChange?.({
                channel_type: options.map(([value]) => value),
              });
            }}
          >
            <Trans>Markera alla</Trans>
          </CommandItem>
        )}
      </CommandGroup>

      <CommandSeparator />

      <CommandGroup>
        {options.map(([channelType, label]) => {
          const isChecked = isArray
            ? value.includes(channelType)
            : value === channelType;

          return (
            <CommandItem
              data-filter-value={channelType}
              key={channelType}
              onSelect={() => {
                if (isChecked) {
                  onChange?.({
                    channel_type: isArray
                      ? value.filter((it) => it !== channelType)
                      : undefined,
                  });
                } else {
                  onChange?.({
                    channel_type: isArray
                      ? [...value, channelType]
                      : value
                        ? [value, channelType]
                        : [channelType],
                  });
                }
              }}
            >
              <Checkbox checked={isChecked} className="pointer-events-none" />
              {label}
            </CommandItem>
          );
        })}
      </CommandGroup>
    </>
  );
}
